import axios from "axios";
import {Loading, Message, MessageBox} from "element-ui";
// import NProgress from "nprogress"; // 进度条插件

// 全局表单提交方式
// 创建axios实例
const serviceTwo = axios.create({
  baseURL: "https://saas-app-tog.ybfresh.com", // api的base_url
  withCredentials: true,
  // baseURL: "http://172.16.2.230:8087/", // api的base_url 
  // baseURL: "http://172.16.4.50:8081", // api的base_url
  // timeout: 10000 // 请求超时时间
});

// request拦截器
var loadinginstace
serviceTwo.interceptors.request.use((config) => {
  loadinginstace = Loading.service({ fullscreen: true })  
  return config;
}, error => {
  loadinginstace.close();
    Message.error({
        message:"请求超时"
    })
  return Promise.reject(err);
});

// respone拦截器
serviceTwo.interceptors.response.use(function(res){
  //在这里对返回的数据进行处理
  loadinginstace.close();
  // 对登陆超时进行处理
  if(res.data.code == 1000){
    setLogin(false);
    MessageBox.alert('会话过期，请重新登录', '提示',{
      confirmButtonText: '确定',
      callback: action => {
        window.location.href="/login"
      }
    })
  }
  if(res.data.code != 200){
    Message.error({
        message:`${res.data.msg}`
    })
  }
  return res.data;
},function(err){
  //Do something with response error
    // console.log(err)
    loadinginstace.close();
    Message.error({
        message:"请求失败,可能是网络错误，"+err
    })
  return  Promise.reject("请求失败,可能是网络错误，"+err);
})

export default serviceTwo;
